export default __webpack_public_path__ + "static/media/resto.d4e3f288.png";